import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IRezervasyonOzet_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IRezervasyonOzet_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  RezervasyonOzetGetir: any[];
  RezervasyonOzetGetir_dummy: any[];
  isComp749360Visible: "visible" | "hidden";
  isComp802912Visible: "visible" | "hidden";
  isComp109624Visible: "visible" | "hidden";
  isComp465219Visible: "visible" | "hidden";
  isComp419022Visible: "visible" | "hidden";
  isComp788316Visible: "visible" | "hidden";
  isComp755344Visible: "visible" | "hidden";
}

export class RezervasyonOzet_ScreenBase extends React.PureComponent<
  IRezervasyonOzet_ScreenProps,
  any
> {
  ml = [
    {
      Id: "bd00ad4a-ed44-61e3-4813-27fcfc1bccc8",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "9f0b40ca-a5d3-4b72-bc52-230e83587430",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "3e5ce0ca-9f74-4fb0-95a3-4f6b64576c59",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 683548, PropertyName: "value", Value: "Uçuş Rezervasyon Özeti" },
        { Id: 165651, PropertyName: "value", Value: "Rezervasyon No:" },
        { Id: 749360, PropertyName: "value", Value: "Taslak" },
        { Id: 802912, PropertyName: "value", Value: "Kayıtlı" },
        { Id: 109624, PropertyName: "value", Value: "Onaylı" },
        { Id: 465219, PropertyName: "value", Value: "Red" },
        { Id: 419022, PropertyName: "value", Value: "İptal" },
        { Id: 788316, PropertyName: "value", Value: "Silindi" },
        { Id: 755344, PropertyName: "value", Value: "Uçuldu" },
        { Id: 933868, PropertyName: "value", Value: "TALEP EDEN" },
        { Id: 28668, PropertyName: "value", Value: "KALKIŞ" },
        { Id: 158447, PropertyName: "value", Value: "VARIŞ" },
        { Id: 267317, PropertyName: "value", Value: "YOLCU SAYISI" },
        { Id: 573705, PropertyName: "value", Value: "UÇUŞTİPİ" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      RezervasyonOzetGetir: [],
      isComp749360Visible: "hidden",
      isComp802912Visible: "hidden",
      isComp109624Visible: "hidden",
      isComp465219Visible: "hidden",
      isComp419022Visible: "hidden",
      isComp788316Visible: "hidden",
      isComp755344Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("rezervasyonozet", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.RezervasyonOzetPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("rezervasyonozet", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("rezervasyonozet", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.RezervasyonOzetPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  RezervasyonOzetPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "RezervasyonOzet/RezervasyonOzetPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.RezervasyonOzetGetir = result?.data.rezervasyonOzetGetir;
    formVars.rezervasyonozet_792401_value = ReactSystemFunctions.toString(
      this,
      stateVars.RezervasyonOzetGetir !== undefined
        ? stateVars.RezervasyonOzetGetir?.length > 0
          ? stateVars.RezervasyonOzetGetir[0].rezervasyonNo
          : null
        : this.state.RezervasyonOzetGetir?.length > 0
        ? this.state.RezervasyonOzetGetir[0].rezervasyonNo
        : null
    );
    formVars.rezervasyonozet_899479_value = ReactSystemFunctions.toString(
      this,
      stateVars.RezervasyonOzetGetir !== undefined
        ? stateVars.RezervasyonOzetGetir?.length > 0
          ? stateVars.RezervasyonOzetGetir[0].kalkisNokta
          : null
        : this.state.RezervasyonOzetGetir?.length > 0
        ? this.state.RezervasyonOzetGetir[0].kalkisNokta
        : null
    );
    formVars.rezervasyonozet_327432_value = ReactSystemFunctions.toString(
      this,
      stateVars.RezervasyonOzetGetir !== undefined
        ? stateVars.RezervasyonOzetGetir?.length > 0
          ? stateVars.RezervasyonOzetGetir[0].kalkisYeri
          : null
        : this.state.RezervasyonOzetGetir?.length > 0
        ? this.state.RezervasyonOzetGetir[0].kalkisYeri
        : null
    );
    formVars.rezervasyonozet_197714_value = ReactSystemFunctions.toString(
      this,
      stateVars.RezervasyonOzetGetir !== undefined
        ? stateVars.RezervasyonOzetGetir?.length > 0
          ? stateVars.RezervasyonOzetGetir[0].varisNokta
          : null
        : this.state.RezervasyonOzetGetir?.length > 0
        ? this.state.RezervasyonOzetGetir[0].varisNokta
        : null
    );
    formVars.rezervasyonozet_634155_value = ReactSystemFunctions.toString(
      this,
      stateVars.RezervasyonOzetGetir !== undefined
        ? stateVars.RezervasyonOzetGetir?.length > 0
          ? stateVars.RezervasyonOzetGetir[0].varisYeri
          : null
        : this.state.RezervasyonOzetGetir?.length > 0
        ? this.state.RezervasyonOzetGetir[0].varisYeri
        : null
    );
    formVars.rezervasyonozet_910775_value = ReactSystemFunctions.toString(
      this,
      stateVars.RezervasyonOzetGetir !== undefined
        ? stateVars.RezervasyonOzetGetir?.length > 0
          ? stateVars.RezervasyonOzetGetir[0].talepEden
          : null
        : this.state.RezervasyonOzetGetir?.length > 0
        ? this.state.RezervasyonOzetGetir[0].talepEden
        : null
    );
    formVars.rezervasyonozet_490896_value = ReactSystemFunctions.value(
      this,
      stateVars.RezervasyonOzetGetir !== undefined
        ? stateVars.RezervasyonOzetGetir?.length > 0
          ? stateVars.RezervasyonOzetGetir[0].kalkisSaat
          : null
        : this.state.RezervasyonOzetGetir?.length > 0
        ? this.state.RezervasyonOzetGetir[0].kalkisSaat
        : null
    );
    formVars.rezervasyonozet_671253_value = ReactSystemFunctions.value(
      this,
      stateVars.RezervasyonOzetGetir !== undefined
        ? stateVars.RezervasyonOzetGetir?.length > 0
          ? stateVars.RezervasyonOzetGetir[0].varisSaat
          : null
        : this.state.RezervasyonOzetGetir?.length > 0
        ? this.state.RezervasyonOzetGetir[0].varisSaat
        : null
    );
    formVars.rezervasyonozet_129172_value = ReactSystemFunctions.toString(
      this,
      stateVars.RezervasyonOzetGetir !== undefined
        ? stateVars.RezervasyonOzetGetir?.length > 0
          ? stateVars.RezervasyonOzetGetir[0].yolcuAdet
          : null
        : this.state.RezervasyonOzetGetir?.length > 0
        ? this.state.RezervasyonOzetGetir[0].yolcuAdet
        : null
    );
    formVars.rezervasyonozet_931178_value = ReactSystemFunctions.toString(
      this,
      stateVars.RezervasyonOzetGetir !== undefined
        ? stateVars.RezervasyonOzetGetir?.length > 0
          ? stateVars.RezervasyonOzetGetir[0].ucusTipiAd
          : null
        : this.state.RezervasyonOzetGetir?.length > 0
        ? this.state.RezervasyonOzetGetir[0].ucusTipiAd
        : null
    );
    stateVars.isComp749360Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.RezervasyonOzetGetir !== undefined
            ? stateVars.RezervasyonOzetGetir?.length > 0
              ? stateVars.RezervasyonOzetGetir[0].onayDurumu
              : null
            : this.state.RezervasyonOzetGetir?.length > 0
            ? this.state.RezervasyonOzetGetir[0].onayDurumu
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp802912Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.RezervasyonOzetGetir !== undefined
            ? stateVars.RezervasyonOzetGetir?.length > 0
              ? stateVars.RezervasyonOzetGetir[0].onayDurumu
              : null
            : this.state.RezervasyonOzetGetir?.length > 0
            ? this.state.RezervasyonOzetGetir[0].onayDurumu
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp109624Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.RezervasyonOzetGetir !== undefined
            ? stateVars.RezervasyonOzetGetir?.length > 0
              ? stateVars.RezervasyonOzetGetir[0].onayDurumu
              : null
            : this.state.RezervasyonOzetGetir?.length > 0
            ? this.state.RezervasyonOzetGetir[0].onayDurumu
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("2", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp465219Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.RezervasyonOzetGetir !== undefined
            ? stateVars.RezervasyonOzetGetir?.length > 0
              ? stateVars.RezervasyonOzetGetir[0].onayDurumu
              : null
            : this.state.RezervasyonOzetGetir?.length > 0
            ? this.state.RezervasyonOzetGetir[0].onayDurumu
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("3", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp419022Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.RezervasyonOzetGetir !== undefined
            ? stateVars.RezervasyonOzetGetir?.length > 0
              ? stateVars.RezervasyonOzetGetir[0].onayDurumu
              : null
            : this.state.RezervasyonOzetGetir?.length > 0
            ? this.state.RezervasyonOzetGetir[0].onayDurumu
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("4", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp788316Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.RezervasyonOzetGetir !== undefined
            ? stateVars.RezervasyonOzetGetir?.length > 0
              ? stateVars.RezervasyonOzetGetir[0].onayDurumu
              : null
            : this.state.RezervasyonOzetGetir?.length > 0
            ? this.state.RezervasyonOzetGetir[0].onayDurumu
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("5", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp755344Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.RezervasyonOzetGetir !== undefined
            ? stateVars.RezervasyonOzetGetir?.length > 0
              ? stateVars.RezervasyonOzetGetir[0].onayDurumu
              : null
            : this.state.RezervasyonOzetGetir?.length > 0
            ? this.state.RezervasyonOzetGetir[0].onayDurumu
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("6", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.RezervasyonOzetPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  RezervasyonOzetPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.rezervasyonozet_792401_value = ReactSystemFunctions.toString(
      this,
      stateVars.RezervasyonOzetGetir !== undefined
        ? stateVars.RezervasyonOzetGetir?.length > 0
          ? stateVars.RezervasyonOzetGetir[0].rezervasyonNo
          : null
        : this.state.RezervasyonOzetGetir?.length > 0
        ? this.state.RezervasyonOzetGetir[0].rezervasyonNo
        : null
    );

    stateVars.isComp749360Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.RezervasyonOzetGetir !== undefined
            ? stateVars.RezervasyonOzetGetir?.length > 0
              ? stateVars.RezervasyonOzetGetir[0].onayDurumu
              : null
            : this.state.RezervasyonOzetGetir?.length > 0
            ? this.state.RezervasyonOzetGetir[0].onayDurumu
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp802912Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.RezervasyonOzetGetir !== undefined
            ? stateVars.RezervasyonOzetGetir?.length > 0
              ? stateVars.RezervasyonOzetGetir[0].onayDurumu
              : null
            : this.state.RezervasyonOzetGetir?.length > 0
            ? this.state.RezervasyonOzetGetir[0].onayDurumu
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp109624Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.RezervasyonOzetGetir !== undefined
            ? stateVars.RezervasyonOzetGetir?.length > 0
              ? stateVars.RezervasyonOzetGetir[0].onayDurumu
              : null
            : this.state.RezervasyonOzetGetir?.length > 0
            ? this.state.RezervasyonOzetGetir[0].onayDurumu
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("2", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp465219Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.RezervasyonOzetGetir !== undefined
            ? stateVars.RezervasyonOzetGetir?.length > 0
              ? stateVars.RezervasyonOzetGetir[0].onayDurumu
              : null
            : this.state.RezervasyonOzetGetir?.length > 0
            ? this.state.RezervasyonOzetGetir[0].onayDurumu
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("3", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp419022Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.RezervasyonOzetGetir !== undefined
            ? stateVars.RezervasyonOzetGetir?.length > 0
              ? stateVars.RezervasyonOzetGetir[0].onayDurumu
              : null
            : this.state.RezervasyonOzetGetir?.length > 0
            ? this.state.RezervasyonOzetGetir[0].onayDurumu
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("4", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp788316Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.RezervasyonOzetGetir !== undefined
            ? stateVars.RezervasyonOzetGetir?.length > 0
              ? stateVars.RezervasyonOzetGetir[0].onayDurumu
              : null
            : this.state.RezervasyonOzetGetir?.length > 0
            ? this.state.RezervasyonOzetGetir[0].onayDurumu
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("5", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp755344Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.RezervasyonOzetGetir !== undefined
            ? stateVars.RezervasyonOzetGetir?.length > 0
              ? stateVars.RezervasyonOzetGetir[0].onayDurumu
              : null
            : this.state.RezervasyonOzetGetir?.length > 0
            ? this.state.RezervasyonOzetGetir[0].onayDurumu
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("6", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.rezervasyonozet_899479_value = ReactSystemFunctions.toString(
      this,
      stateVars.RezervasyonOzetGetir !== undefined
        ? stateVars.RezervasyonOzetGetir?.length > 0
          ? stateVars.RezervasyonOzetGetir[0].kalkisNokta
          : null
        : this.state.RezervasyonOzetGetir?.length > 0
        ? this.state.RezervasyonOzetGetir[0].kalkisNokta
        : null
    );

    formVars.rezervasyonozet_327432_value = ReactSystemFunctions.toString(
      this,
      stateVars.RezervasyonOzetGetir !== undefined
        ? stateVars.RezervasyonOzetGetir?.length > 0
          ? stateVars.RezervasyonOzetGetir[0].kalkisYeri
          : null
        : this.state.RezervasyonOzetGetir?.length > 0
        ? this.state.RezervasyonOzetGetir[0].kalkisYeri
        : null
    );

    formVars.rezervasyonozet_197714_value = ReactSystemFunctions.toString(
      this,
      stateVars.RezervasyonOzetGetir !== undefined
        ? stateVars.RezervasyonOzetGetir?.length > 0
          ? stateVars.RezervasyonOzetGetir[0].varisNokta
          : null
        : this.state.RezervasyonOzetGetir?.length > 0
        ? this.state.RezervasyonOzetGetir[0].varisNokta
        : null
    );

    formVars.rezervasyonozet_634155_value = ReactSystemFunctions.toString(
      this,
      stateVars.RezervasyonOzetGetir !== undefined
        ? stateVars.RezervasyonOzetGetir?.length > 0
          ? stateVars.RezervasyonOzetGetir[0].varisYeri
          : null
        : this.state.RezervasyonOzetGetir?.length > 0
        ? this.state.RezervasyonOzetGetir[0].varisYeri
        : null
    );

    formVars.rezervasyonozet_910775_value = ReactSystemFunctions.toString(
      this,
      stateVars.RezervasyonOzetGetir !== undefined
        ? stateVars.RezervasyonOzetGetir?.length > 0
          ? stateVars.RezervasyonOzetGetir[0].talepEden
          : null
        : this.state.RezervasyonOzetGetir?.length > 0
        ? this.state.RezervasyonOzetGetir[0].talepEden
        : null
    );

    formVars.rezervasyonozet_490896_value = ReactSystemFunctions.value(
      this,
      stateVars.RezervasyonOzetGetir !== undefined
        ? stateVars.RezervasyonOzetGetir?.length > 0
          ? stateVars.RezervasyonOzetGetir[0].kalkisSaat
          : null
        : this.state.RezervasyonOzetGetir?.length > 0
        ? this.state.RezervasyonOzetGetir[0].kalkisSaat
        : null
    );

    formVars.rezervasyonozet_671253_value = ReactSystemFunctions.value(
      this,
      stateVars.RezervasyonOzetGetir !== undefined
        ? stateVars.RezervasyonOzetGetir?.length > 0
          ? stateVars.RezervasyonOzetGetir[0].varisSaat
          : null
        : this.state.RezervasyonOzetGetir?.length > 0
        ? this.state.RezervasyonOzetGetir[0].varisSaat
        : null
    );

    formVars.rezervasyonozet_129172_value = ReactSystemFunctions.toString(
      this,
      stateVars.RezervasyonOzetGetir !== undefined
        ? stateVars.RezervasyonOzetGetir?.length > 0
          ? stateVars.RezervasyonOzetGetir[0].yolcuAdet
          : null
        : this.state.RezervasyonOzetGetir?.length > 0
        ? this.state.RezervasyonOzetGetir[0].yolcuAdet
        : null
    );

    formVars.rezervasyonozet_931178_value = ReactSystemFunctions.toString(
      this,
      stateVars.RezervasyonOzetGetir !== undefined
        ? stateVars.RezervasyonOzetGetir?.length > 0
          ? stateVars.RezervasyonOzetGetir[0].ucusTipiAd
          : null
        : this.state.RezervasyonOzetGetir?.length > 0
        ? this.state.RezervasyonOzetGetir[0].ucusTipiAd
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  RezervasyonOzetComponent_38256_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.RezervasyonOzetPageInit();
    }
  }
}
